// extracted by mini-css-extract-plugin
export default {"message-box":"message-box--yScZT","message-title":"message-title--Xbe9p","footer":"footer--YRRSW","footer-item":"footer-item--b_ziH"};